import { isBokaTestServiceURL } from './urlHelper';

const { FEATUREFLAGS } = CSS_CONFIG;
type FeatureType = keyof Omit<typeof FEATUREFLAGS, 'bokaTestService'>;

export const isFeatureEnabled = (feature: FeatureType): boolean => {
  if (isBokaTestServiceURL()) {
    return FEATUREFLAGS.bokaTestService[feature];
  }
  return FEATUREFLAGS[feature];
};
